import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";

//import range from './range';

export default angular
  .module("app.filters", [])
  .filter("dayFilter", function () {
    return function (input, total) {
      total = parseInt(total);

      for (var i = 0; i < total; i++) {
        if (i !== 0 && i % 10 === 0) {
          input.push(i);
        }
      }

      return input;
    };
  })
  .filter("rangeFilter", function () {
    return function (input, total) {
      total = parseInt(total);

      for (var i = 0; i < total; i++) {
        input.push(i);
      }
      return input;
    };
  })
  .filter("rangeFilterFifteen", function () {
    return function (input, total) {
      total = parseInt(total);

      for (var i = 0; i < total; i++) {
        if (i % 15 === 0) {
          input.push(i);
        }
      }

      return input;
    };
  })
  .filter("escapeFilter", function () {
    return function (input) {
      if (input) {
        var amp_count = (input.match(/&amp;/g) || []).length;
        //console.log('input');
        //console.dir(input);
        //console.dir(amp_count);
        try {
          for (var i = 0; i < amp_count; i++) {
            input = input.replace(/&amp;/g, "&");
          }
        } finally {
          return input;
        }
      }
    };
  })
  .filter("parseLink", function ($sce) {
    var url = /(\b(https?|http):\/\/[A-Z0-9+&@#\/%?=~_|!:,.;-]*[-A-Z0-9+&@#\/%=~_|])/gim;
    var www = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    var email = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
    var phone = /(^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$)/gim;

    return function (text) {
      if (text.match(url)) {
        text = text.replace(url, '<a href="$1">$1</a>');
      }
      if (text.match(www)) {
        text = text.replace(www, '$1<a href="http://$2" target="_blank">$2</a>');
      }
      if (text.match(email)) {
        text = text.replace(email, '<a href="mailto:$1">$1</a>');
      }
      if (text.match(phone)) {
        text = text.replace(phone, '<a href="tel:$1">$1</a>');
      }
      return $sce.trustAsHtml(text);
    };
  });



// WEBPACK FOOTER //
// ./client/app/filters/filters.js